import { get } from '@/utils/request';

export const banks = (params) => {
  return get('/api/v1/banks', params);
};
